/**
 * Photography / asset briefs for replacing editorial stock with MossMatrix-branded shoots.
 * Use captions under key images or hand to your photographer — not shown as a customer-facing list by default.
 */
export const PHOTO_BRIEF = {
  jarGoldCloseup: "MossMatrix gold gel jar macro — spoon lift showing texture, marble or linen surface.",
  jarPurpleSideBySide: "Gold vs purple jars side-by-side on shelf, soft window light, labels legible.",
  spoonTexture: "Overhead: gel ribbon on spoon above open jar — focus on glossy body, not drips.",
  smoothiePrep:
    "Hands pouring gel into a home blender on the counter (your toppings stay at home, not in shipped jars). Lifestyle, not clinical.",
  teaOats: "Split frame: gel stirred into herbal tea + folded into morning oats.",
  fridgeStorage: "Fridge shelf with sealed MossMatrix jar, clean spoon on saucer beside it.",
  driedFoilBag: "Sealed foil ziplock of dried sea moss next to prepared gel jar — contrast convenience vs shelf life.",
  unboxing: "Natural kraft box, tissue, jar with lid — premium unboxing, no clutter.",
  customerHolding: "Customer holding jar at home kitchen — consent-forward, diverse casting.",
};
